// Node Module Imports
import React, { useEffect, useState } from 'react'

import styled from 'styled-components'

// Style Imports
import {
  above, colors, fontSize, space,
} from '../../style/design-system'
// Utility Imports
import headerLinks from '../../utils/static-data/headerLinks'
import navHeadings from '../../utils/static-data/navHeadings'
import Chevron from '../uma-svgs/Chevron'
import NavSub from './NavSub'

const NavPrimary = ({ className, closeMobileNav }) => {
  const [subNavExpandedName, setSubNavExpandedName] = useState('')
  const [slugAndParams, setSlugAndParams] = useState('')

  /**
   * This useEffect runs only on component mount
   * Grab the slug and query params to pass to the NavSub component.
   * There, it will be used to apply proper styling for active pages' nav links when those links are not Gatsby Links
   * This is run here and passed to children to prevent it from running every time each of the five children mount.
   *
   */
  useEffect(() => {
    setSlugAndParams(`${window.location.pathname}${window.location.search}`)
  }, [subNavExpandedName])

  // called when the value of subNavExpanded state changes
  useEffect(() => {
    // if a sub nav is expanded...
    if (subNavExpandedName) {
      window.addEventListener('click', handleWindowClick)
    }

    // unregister the event listener on component cleanup
    // https://reactjs.org/docs/hooks-effect.html#example-using-hooks-1
    return () => window.removeEventListener('click', handleWindowClick)

  // run this useEffect only when the value of the subNavExpandedName state changes
  }, [subNavExpandedName])

  //! This is called from a click when there is a sub nav expanded
  const handleWindowClick = (e) => {
    //* if the click was on a nav header...
    if (e.target.dataset.name === 'nav-header' && e.target.dataset.headername != subNavExpandedName) {
      setSubNavExpandedName(e.target.dataset.headername)
    }
    else {
      setSubNavExpandedName('')
    }
  }

  //! called from a click on a nav header
  const handleClick = (headername) => {
    //* check to see if there is a sub nav expanded; if not, proceed
    if (!subNavExpandedName) {
      setSubNavExpandedName(headername)
    }
  }

  const renderNavItems = (arr) => arr.map((item) => (
    <li className="nav-li pointer d-lg-inline-block" key={item.name}>
      <button
        className={item.name}
        data-name="nav-header"
        data-headername={item.name}
        onClick={() => handleClick(item.name)}>
        <Chevron
          className={subNavExpandedName == item.name ? 'mobile-only chevron chevron-south' : 'mobile-only chevron'}
          color={colors.umaGreen}
          direction="east"
          width="16px" />
        {item.text}
      </button>
      <NavSub
        listToRender={headerLinks[item.name]}
        isExpanded={subNavExpandedName === item.name}
        slugAndParams={slugAndParams}
        closeMobileNav={closeMobileNav} />
    </li>
  ))

  return (
    <ul className={className}>
      {renderNavItems(navHeadings)}
    </ul>
  )
}

export default styled(NavPrimary)`
  padding: 0;
  margin: 0;

  .nav-li {
    position: relative;
    display: block;
    list-style: none;
    font-size: 1rem;

    button {
      background: transparent;
      border: none;
      color: ${colors.umaDarkBlue};
      font-family: acumin-pro-condensed;
      font-size: ${fontSize.h};
      font-weight: 700;
      margin: 0 0.8rem;
      padding: 0;

      ${above.lg`
        font-size: ${fontSize.e};
      `}

      ${above.xl`
        font-size: ${fontSize.g};
        margin: 0 1rem;
      `}

      ${above.xxl`
        font-size: ${fontSize.h};
        margin: 0 ${space.f};
      `}

      &:active,
      &:focus,
      &:hover {
        color: ${colors.dev.blue.b()};
        outline: none;
      }
    }

    .chevron {
      margin-right: .625rem;
      transition: all .2s ease-in-out;

      &.mobile-only {
        ${above.lg`
          display: none;
        `}
      }

      &.chevron-south {
        transform: rotate(0deg);
      }
    }
  }

  .subnav-li {
    font-family: acumin-pro;
    font-weight: normal;
    font-size: 1rem;
  }
`
